import { Button } from "@material-ui/core";
import * as React from "react";
import { t } from "../../i18n/util";
import { THEME } from "../../theme/ThemeStore";

export const BackButton = (props: { onClick(): void; style?: React.CSSProperties }) => {
    return (
        <Button
            style={{
                fontWeight: 600,
                color: THEME.customColors.primary,
                textTransform: "lowercase",
                ...props.style
            }}
            onClick={props.onClick}
        >
            <img src={THEME.Images.icChevronLeftOrange} alt="" style={{ height: 12, width: 12, marginRight: 16 }} />
            {t("screen.details.button.back")}
        </Button>
    );
};
